


























































































import { Component, Mixins, Prop } from 'vue-property-decorator';
import BurgerMenu from './burger-menu/BurgerMenu.vue';
import AvailabilityClock from '../availability-clock/AvailabilityClock.vue';
import QuickSearch from '../quick-search/QuickSearch.vue';
import VinSearch from '../vin-search/VinSearch.vue';
import BaseMixin from '@/mixins/BaseMixin';
import Dictionary from '@/types/Dictionary';
import NavigationItem from './NavigationItem.vue';
import { SubMenuItem } from '@/entities/navigation/SubMenuItem';
import { SubMenuInfo } from '@/entities/navigation/SubMenuInfo';
import { notNullOrUndefined } from '@/helper/notNullOrUndefined';

@Component({
    components: {
        BurgerMenu,
        AvailabilityClock,
        QuickSearch,
        VinSearch,
    },
})
export default class Navigation extends Mixins(BaseMixin) {
    @Prop(String)
    private homeLink!: string;
    @Prop(String)
    private detailSearchLink!: string;
    @Prop(String)
    private catalogueSearchLink!: string;
    @Prop(String)
    private nextPossibleShippingDateTimeISO8601!: string;
    @Prop(String)
    private subMenuItemsJson!: string;

    private subMenuItems!: Dictionary<SubMenuInfo[]>;
    private selectedNavigationItem: string = '';
    private selectedSubMenuItemLvl1: string = '';
    private selectedSubMenuItemLvl2: string = '';

    // called by vue
    public created(): void {
        this.subMenuItems = JSON.parse(this.subMenuItemsJson);
    }

    public get hasSelectedNavItemSubMenuItems(): boolean {
        return Array.isArray(this.subMenuItems[this.selectedNavigationItem]);
    }

    public get hasSelectedNavItemLvl2SubMenuItems(): boolean {
        if (this.subMenuItems[this.selectedNavigationItem]) {
            return (
                this.subMenuItems[this.selectedNavigationItem]
                    .flatMap((item) => item.secondLevelItems)
                    .filter((item) => notNullOrUndefined(item)).length > 0
            );
        } else {
            return false;
        }
    }

    public get subMenuLvl1Items(): Array<{ link: string; name: string }> {
        if (!this.hasSelectedNavItemSubMenuItems) {
            return [];
        }
        return this.subMenuItems[this.selectedNavigationItem].map((item) => item.firstLevelItem);
    }

    public get subMenuLvl2Items(): Array<{ link: string; name: string }> {
        if (!this.hasSelectedNavItemSubMenuItems || this.selectedSubMenuItemLvl1 === '') {
            return [];
        }

        const activeSubMenuInfo = this.subMenuItems[this.selectedNavigationItem].find(
            (item) => item.firstLevelItem.link === this.selectedSubMenuItemLvl1
        );

        if (activeSubMenuInfo) {
            return activeSubMenuInfo!.secondLevelItems;
        }

        return [];
    }

    // public - gets called by NavigationItem
    public onMouseOverItem(link: string): void {
        this.selectedNavigationItem = link;
    }

    private resetSelectedItems(): void {
        this.selectedNavigationItem = '';
        this.selectedSubMenuItemLvl1 = '';
        this.selectedSubMenuItemLvl2 = '';
    }
}
